<!--vwui-header-divider-bar>
    <vwui-search
        class="search-projects"
        [ngModel]="searchValue"
        [placeholder]="'PAGE_PROJECT_LIBRARY_ITEMS.filter.search.label' | translate"
        (vwuiChange)="search($event.detail.value)"
        a11yHotkeyFocusSearch
    ></vwui-search>
    <ng-select
        class="search-status"
        [ngModel]="searchStatuses"
        [items]="statuses"
        bindValue="id"
        bindLabel="name"
        [placeholder]="'PAGE_PROJECTEN.filter.status.placeholder' | translate"
        (change)="searchStatusChanged($event)"
        multiple="true">
    </ng-select>
    <ng-select
        class="search-classification"
        [ngModel]="searchClassifications"
        [items]="classifications"
        bindValue="id"
        bindLabel="name"
        [placeholder]="'PAGE_PROJECTEN.filter.classification.placeholder' | translate"
        (change)="searchCategoryChanged($event)"
        multiple="true"
    ></ng-select>
    <ng-select
        class="search-construction-costs"
        [ngModel]="searchConstructionCosts"
        [items]="constructionCostOptions"
        bindValue="id"
        bindLabel="name"
        [placeholder]="'PAGE_PROJECTEN.filter.constructionCosts.placeholder' | translate"
        (change)="searchConstructionCostsChanged($event)"
        [multiple]="false"
    ></ng-select>
</vwui-header-divider-bar-->

<vwui-header-divider-bar class="vwui-header-divider-bar--no-bottom">
    @if(isAllProjectsPage) {
        <h2 a11yPageTitleLevel="1">{{ 'PAGE_PROJECTEN.title_all' | translate}}</h2>
    } @else {
        <h2 a11yPageTitleLevel="1">{{ 'PAGE_PROJECTEN.title' | translate}}</h2>
        <ng-container>
            <vwui-datepicker
                [flatpickrOptions]="{dateFormat: 'Y-m-d', altFormat: 'd-m-Y', altInput: true, allowInput: true, locale: 'nl'}"
                [(ngModel)]="searchStartDate"
                [maxDate]="searchEndDate"
                (change)="searchDateChanged()"
            ></vwui-datepicker>
        </ng-container>
        <ng-container>
            <vwui-datepicker
                [flatpickrOptions]="{dateFormat: 'Y-m-d', altFormat: 'd-m-Y', altInput: true, allowInput: true, locale: 'nl'}"
                [(ngModel)]="searchEndDate"
                [minDate]="searchStartDate"
                (change)="searchDateChanged()"
            ></vwui-datepicker>
        </ng-container>
        <ng-container>
            <vwui-button class="is-primary flex-end" [disabled]="isEmailNotificationSend" (click)="triggerEmailNotification()">Test email notification</vwui-button>
        </ng-container>
    }
</vwui-header-divider-bar>

<div class="mt-lg">
    @if (projectsLength === 0 && !hasSearchFilter()) {
        <vwui-empty-state [messageTitle]="'PAGE_PROJECTEN.no_projects.message_title' | translate"></vwui-empty-state>
    }

    @if (projectsLength !== 0 || hasSearchFilter()) {
        <vwui-table [compactable]="false">
                <vwui-pagination
                slot="table-pagination"
                [totalItems]="currentPageData?.page?.totalElements"
                [totalPages]="currentPageData?.page?.totalPages"
                [currentPage]="currentPageData?.page?.number + 1"
                [firstItem]="firstItem()"
                [lastItem]="lastItem()"
                (vwuiPaginationChange)="setPage($event.detail)"
            ></vwui-pagination>

            <vwui-table-row>
                @for (column of tableConfig.columns; track column) {
                    @if(isAllProjectsPage || !column.showOnAllPage) {
                        <vwui-table-header>
                                @if (column.tooltip === undefined) {
                                    <ng-container> {{ column.header }} </ng-container>
                                } @else {
                                    <vwui-tooltip [label]="column.tooltip | translate"> {{ column.header }}</vwui-tooltip>
                                }
                        </vwui-table-header>
                    }
                }
            </vwui-table-row>

            @if (loadingSpinnerService.isSpinnerVisible()) {
                <vwui-table-row>
                    <vwui-spinner></vwui-spinner>
                </vwui-table-row>
            }

            @if (projectsLength === 0 && !loadingSpinnerService.isSpinnerVisible()) {
                <vwui-table-row>
                    <div class="table-row__text">{{ 'PAGE_PROJECTEN.no_projects.search_title' | translate }}</div>
                </vwui-table-row>
            }

            <ng-container>
                @for (item of projects | async; track item) {
                   <vwui-table-row class="vwui-table-row--with-hover" (click)="onProjectClick(item)" a11yKeyboardClickable>
                        <vwui-table-column>
                            {{ item.name }}
                        </vwui-table-column>

                        <vwui-table-column>
                            {{ item.company }}
                        </vwui-table-column>

                       <vwui-table-column>
                            {{ item.projectInfo?.client | namesFormat }}
                        </vwui-table-column>

                        <vwui-table-column>
                            &euro; {{ item.projectInfo?.constructionCostsAsText }}
                        </vwui-table-column>

                        <vwui-table-column>
                            {{ item.projectInfo?.tenderCosts | tenderCostsRange }}
                        </vwui-table-column>

                        <vwui-table-column>
                            {{ item.projectInfo?.answerHeightAbove }}
                        </vwui-table-column>

                       <vwui-table-column>
                           {{ item.projectInfo?.answerHeightUnder }}
                       </vwui-table-column>

                       <vwui-table-column>
                           {{ item.projectInfo?.bvo }}
                       </vwui-table-column>

                       <vwui-table-column>
                           {{ item.projectInfo?.tenderDate }}
                       </vwui-table-column>

                       @if (isAllProjectsPage) {
                           <vwui-table-column>
                               ?
                           </vwui-table-column>
                       }
                    </vwui-table-row>
                }
            </ng-container>
        </vwui-table>
    }
</div>
